import { MEETINGS_TAB_BASE_PATH_LEGACY, MEETINGS_TAB_BASE_PATH_REBRAND } from 'hooks/home/meetings_tab_paths'

export const USER_ONBOARDING_STEPS = [
  '/app/ai_notetaker_wizard',
  '/app/ai_notetaker_wizard/recording_rules'
]


export const INITIAL_PAGE_SIZE = 100
export const PAGE_SIZE = 10

// TODO: Add 'outlook' once the feature flag is enabled for all users
export const VALID_MI_CALENDARS = ['google']

/** Personal-scope meetings home URL; use when redirecting after MI flows (respects app-shell rebrand flag). */
export const getMeetingsUserMePath = (isRebrandAppShellIa) => (
  `${isRebrandAppShellIa ? MEETINGS_TAB_BASE_PATH_REBRAND : MEETINGS_TAB_BASE_PATH_LEGACY}/user/me`
)

export const MI_MEETINGS_TOUR = {
  STEP_ONE: 'see_meetings',
  STEP_TWO: 'find_meetings',
  STEP_THREE: 'control_meetings',
}

export const MEETING_RECAP_TOUR = {
  STEP_ONE: 'recap_step_one',
  STEP_TWO: 'recap_step_two',
  STEP_THREE: 'recap_step_three',
}

export const MR_ONBOARDING_WIZARD = {
  ACKNOWLEDGEMENT: 'acknowledgement',
  RECORDING_RULES: 'recording_rules',
  RECORDING_RULES_AUTO_LOAD: 'auto_recording_rules',
  FREE_MAIL: 'mail_type',
  AUTO_LOAD: 'autoload',
  LOADING: 'loading',
  USER_TRIGGERED: 'user_triggered'
}

export const WIZARD_MODAL_SEEN_MAX = 3
export const SESSION_KEY = 'mi_onboarding_wizard_session_shown'
export const AUTO_SHARE_DISCOVERY_SESSION_KEY = 'auto_share_discovery_modal_session_shown'

export const WIZARD_LOADER_TIMER_LENGTH = 2000

// Include Teams only if the flag is enabled
const VIDEO_LOCATION_KINDS = ['ZOOM', 'GOOGLE_MEET']
const VIDEO_LOCATION_TYPES = ['zoom_conference', 'google_conference']
export const getVideoLocationKinds = (hasMsTeamsFlag = false) => {
  const kinds = [...VIDEO_LOCATION_KINDS]
  if (hasMsTeamsFlag) {
    kinds.push('MICROSOFT_TEAMS')
  }
  return kinds
}

/** Integrations that appear in recording rules but have no push-recaps toggle (connection only). */
export const INTEGRATION_WITHOUT_TOGGLE = ['zapier']

/** All integrations supported in recording rules (with or without toggle). */
export const ALL_RECORDING_RULES_INTEGRATIONS = ['hubspot', 'salesforce', ...INTEGRATION_WITHOUT_TOGGLE]

export const getVideoLocationTypes = (hasMsTeamsFlag = false) => {
  const types = [...VIDEO_LOCATION_TYPES]
  if (hasMsTeamsFlag) {
    types.push('microsoft_teams_conference')
  }
  return types
}

// Recap video-focused layout: stacked (narrow) vs two-column (wide).

// Stacked when main container width is at or below this and no shell side panel (Callie, shareable, etc.) is open. */
export const RECAP_STACKED_MAIN_CONTAINER_MAX_PX = 959
/** Stacked when viewport is at or below this while a shell side panel (Callie, shareable, etc.) is open.
 *  Recap onboarding spotlight (step two) uses the same threshold. */
export const RECAP_STACKED_WITH_SIDE_PANEL_OPEN_VIEWPORT_MAX_PX = 1600

export const ONBOARDING_VIDEO_ID = '6ephc3ayz2'
